import {getCookie, setCookie} from "@helpers/cookie/cookie";
import {UiTheme} from "../types";
import {useEffect} from "react";
import {SetStatePropsType} from "@baseTypes/base";
import {useThemeContext} from "@view/theme/context/hooks/useThemeContext";
import {saveUiSettings} from "@view/theme/api/uiSettings";

export function useSetTheme() {
    const {setTheme: setThemeContext} = useThemeContext()
    const setTheme = (theme: UiTheme) => {
        setThemeContext(theme)
        setCookie('theme', theme)
        saveUiSettings({theme})
    }

    return {setTheme}
}

export function useInitialTheme(setTheme: SetStatePropsType<UiTheme>, forcedTheme?: UiTheme) {

    useEffect(() => {
        const theme = forcedTheme ?? getCookie('theme');

        if (theme && (theme === 'dark' || theme === 'light')) {
            if (theme === 'dark') {
                document.body.classList.add('darkMode')
            }
            setTheme(theme);
            return
        }

        const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');

        if (prefersDarkScheme.matches) {
            document.body.classList.add('darkMode')
            setTheme('dark')
        }
    }, [forcedTheme])


}